import { Icon } from "@nulogy/components";
import { formatDate } from "components/helpers/format";
import WorkBlock from "domain/WorkBlock";
import isNil from "lodash/isNil";
import React from "react";
import styled from "styled-components";

const DueDateWrapper = styled.div`
  vertical-align: middle;
  line-height: 16px;
`;

const WorkBlockPastDue = styled.div`
  display: flex;
  align-items: center;
  line-height: 16px;
`;

const PastDueDate = styled.span`
  margin-left: 4px;
`;

const PastDue = ({ dueDate }) => (
  <WorkBlockPastDue>
    <Icon data-testid="icon" icon="calendarClock" size="16px" />
    <PastDueDate data-testid="due-date">Due {formatDueDate(dueDate)}</PastDueDate>
  </WorkBlockPastDue>
);

export default function DueDate({ workBlock }) {
  const workBlockPastDue = WorkBlock.isPastDue(workBlock);
  const dueDate = workBlock.workOrder.due;

  if (workBlockPastDue) {
    return PastDue({ dueDate });
  }
  return <DueDateWrapper data-testid="due-date">Due {formatDueDate(dueDate)}</DueDateWrapper>;
}

function formatDueDate(dueDate) {
  if (isNil(dueDate)) return "N/A";

  return formatDate(dueDate);
}
